const INITIAL_STATE = {
    usuarioIniciado: true,
    usuario: { nb: null },
    usuarioLogado: false,
    usuarioAutorizado: false,
    loadingBasicInfo: true,
    atualizacao: 0,
    dadosDivergentes: [],
    message:'',
    searchComplete: true,  
    dadosInscricao: null
};

const prepareNbsToView = (listaBeneficios) => {
    let nbsView = [];
    let bAtivo = [];
    let bInativo = [];
    let bIndeferido = [];

    if (listaBeneficios) {

        for (let i = 0; i < listaBeneficios.length; i++) {

            if (listaBeneficios[i].situacao === "ATIVO") {
                bAtivo.push(listaBeneficios[i]);
            } else if (listaBeneficios[i].situacao === "INDEFERIDO") {
                bIndeferido.push(listaBeneficios[i]);
            } else {
                bInativo.push(listaBeneficios[i]);
            }
        }
        nbsView = bAtivo.concat(bInativo.concat(bIndeferido));

    }
  return nbsView
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case 'RESET_MITOKEN':
            delete state.miToken            
            return { ...state }

    case 'USUARIO_LOGADO':
      return { 
        ...state, 
        usuario: { ...state.usuario, ...action.payload }, 
        usuarioLogado: true, 
        usuarioAutorizado: action.usuarioAutorizado, 
        miToken: action.payload.miToken ? action.payload.miToken : undefined
      };

    case 'SET_USUARIO_AUTORIZADO':
      return { ...state, usuarioAutorizado: action.payload, loadingBasicInfo: false }

        case 'USUARIO_DESLOGADO_LITE':
      return { ...INITIAL_STATE };

        case 'USUARIO_DESLOGADO':
      return { ...INITIAL_STATE };

        case 'ATUALIZACAO_APP':
            return { ...state, atualizacao: action.payload };

        case 'BUSCA_NBS':
      return { ...state, loadingBasicInfo: true, dadosDivergentes: [] };
        
        case 'BUSCA_NBS_ERRO':
      return { 
        ...state, 
        usuario: { ...state.usuario, nb: state.usuario.nb }, 
        pessoaCnis: state.pessoaCnis ? state.pessoaCnis : "erro", 
        loadingBasicInfo: false
      };

        case 'BUSCA_NBS_CONCLUIDA':
            return {
                ...state,
                miToken: action.payload.miToken,
                loadingBasicInfo: action.payload.pessoaCnis === "not found",
                usuario: {
                    ...state.usuario,
                    perfil: action.payload.perfil,
                    nb: action.payload.nbs,
                    nome: action.payload.pessoaCnis ? action.payload.pessoaCnis.nome : null,
                    nomeRepresentado: action.payload.pessoaCnis ? action.payload.pessoaCnis.nome : null,
                    nitPrincipal: action.payload.pessoaCnis ? action.payload.pessoaCnis.nitPrevalente : null,
                    cpf: action.payload.pessoaCnis.cpf || action.payload.cpf
                },
                pessoaCnis: action.payload.pessoaCnis,
                beneficios: (action.payload.nbsJson && action.payload.nbsJson !== "erro") ? prepareNbsToView(action.payload.nbsJson.listaBeneficios) : [],
                dadosDivergentes: [],
        dadosInscricao: null,
        nbsJson: action.payload.nbsJson
            };

            case 'DADOS_DIVERGENTES':
                return { ...state, loadingBasicInfo:false, dadosDivergentes: action.payload, message:'' };
            
            case 'ERRO_BUSCA_DADOS_DIVERGENTES':
                return {  ...state,loadingBasicInfo:false, dadosDivergentes: [], message: action.payload.message };     
                
            case 'DADOS_INSCRICAO_INSS':
                const {pessoaINSS, miToken } = action.payload;
                return { ...state, loadingBasicInfo: false, message: '', dadosInscricao: miToken, pessoaCnis:pessoaINSS};
            case 'DADOS_INSCRICAO_INSS_ERRO':
                const {pessoa, hasMessageError } = action.payload || {}
                return { ...state, loadingBasicInfo: false, message: '', dadosInscricao: null, pessoaCnis:pessoa, hasMessageError};
            case 'DADOS_INSCRICAO_PROCURADOR':                
                return { ...state, loadingBasicInfo: false, message: 'erro_procurador', dadosInscricao: null};
            case 'DADOS_ATUALIZACAO_INSS_PROCURADOR':                
                return { ...state, loadingBasicInfo: false, message: 'erro_procurador_atualizacao', dadosInscricao: null};    
        default:
            return state;
    }
}

